import { render, staticRenderFns } from "./InviteTeamMemberModal.vue?vue&type=template&id=7aa04e66&"
import script from "./InviteTeamMemberModal.vue?vue&type=script&lang=js&"
export * from "./InviteTeamMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa04e66')) {
      api.createRecord('7aa04e66', component.options)
    } else {
      api.reload('7aa04e66', component.options)
    }
    module.hot.accept("./InviteTeamMemberModal.vue?vue&type=template&id=7aa04e66&", function () {
      api.rerender('7aa04e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/InviteTeamMemberModal.vue"
export default component.exports